var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Watch } from 'vue-property-decorator';
import { getVideosCRM } from '@/shared/utils/Infosets.utils';
import { NotificationService } from '@/services/NotificationService';
import { verifyPiperunToken } from '@/clients/crm';
import Modal from 'components/Modal.vue';
import Tooltip from 'components/Tooltip.vue';
import CrmCardContent from 'components/CrmCardContent.vue';
let PiperunConfigCard = class PiperunConfigCard extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.token = '';
        this.tokenVerified = false;
        this.ocultedToken = true;
        this.openModal = false;
        this.crmIcon = 'statics/images/logos/piperun-logo.png';
        this.companyFields = [
            'Razão Social/Nome Fantasia',
            'CNPJ',
            'Endereço',
            'Situação',
            'Dados Corporativos',
            'Nome do Administrador',
            'Capital Social',
            'Setor',
            'Cnae Primário',
            'Cnae Secundário',
            'Data de Abertura',
            'Faixa de Faturamento da Unidade CNPJ',
            'Faixa de Faturamento da Empresa',
            'Faixa de Funcionários da Unidade CNPJ',
            'Faixa de Funcionarios da Empresa',
            'Natureza Jurídica',
            'Administrador',
            'Facebook',
            'Website',
            'Todos os Emails',
            'Todos os Telefones',
            'Telefones Válidos',
            'Decisores',
            'Emails Principais',
            'Telefones Principais',
            'Origem',
        ];
        this.decisorFields = [
            'Nome',
            'Empresa',
            'E-mail',
            'Posição',
            'Nível',
            'Departamento',
            'Link do linkedIn',
        ];
        this.questions = [
            {
                question: 'Quais planos permitem exportação?',
                answer: 'Todos os planos pagos',
            },
            {
                question: 'Qual nível de permissão meu usuário precisa ter?',
                answer: 'gestor',
            },
            {
                question: 'Onde configurar permissão para criar oportunidades?',
                answer: 'No menu principal, busque a opção "Ajustes e Configurações" e clique. Em seguida, selecione a opção "Funiz e etapas de funil". Clique no ícone de edição, para configurar a permissão de criar oportunidade. Basta habilitar a opção',
            },
            {
                question: 'Onde encontrar os dados das empresas?',
                answer: 'No menu lateral esquerdo em Empresas.',
            },
            {
                question: 'Onde encontrar os dados dos decisores?',
                answer: 'No menu lateral esquerdo passe o mouse em Empresas e clique quando aparecer a opção de Pessoas.',
            },
            {
                question: 'O que acontece se eu exportar 2 vezes a mesma empresa?',
                answer: 'Nosso integrador não irá enviar os dados devido ao cnpj já existir no crm',
            },
        ];
    }
    get tutorialVideoLink() {
        return getVideosCRM('piperun');
    }
    changedOpenModal() {
        this.ocultedToken = true;
    }
    async verifyToken() {
        this.loading = true;
        try {
            await verifyPiperunToken({ token: this.token });
            this.tokenVerified = true;
            this.ocultedToken = true;
            NotificationService.success('Sucesso', 'Seu token foi salvo com sucesso. Agora você pode exportar para o crm!');
        }
        catch (e) {
            NotificationService.error('Error', 'O token selecionado está inválido');
        }
        this.loading = false;
    }
    changeToken() {
        this.token = '';
        this.tokenVerified = false;
    }
};
__decorate([
    Watch('openModal')
], PiperunConfigCard.prototype, "changedOpenModal", null);
PiperunConfigCard = __decorate([
    Component({
        name: 'PiperunConfigCard',
        components: {
            Modal,
            Tooltip,
            CrmCardContent,
        },
    })
], PiperunConfigCard);
export default PiperunConfigCard;
